@if(isVisible) {
  <div class="typing-indicator">
    <mat-spinner [diameter]="20" color="accent"></mat-spinner>
    <span class="typing-indicator__message">{{ message }}</span>
  </div>
}
